import publicPresentationApi from "../../../api/publicPresentationAxios";

const GENERIC_NOT_FOUND = "Цю презентацію не знайдено.";
const GENERIC_UNAVAILABLE = "Ця презентація більше недоступна.";
const GENERIC_LOAD_ERROR = "Не вдалося завантажити презентацію.";

export function classifyPublicPresentationError(error) {
  const status = error && error.response && error.response.status;
  if (status === 410) {
    return { kind: "unavailable", message: GENERIC_UNAVAILABLE };
  }
  if (status === 404 || status === 401) {
    return { kind: "not_found", message: GENERIC_NOT_FOUND };
  }
  if (status === 429) {
    return { kind: "transient", message: "Забагато запитів. Спробуйте пізніше." };
  }
  if (status >= 500 && status <= 599) {
    return { kind: "transient", message: "Сервіс тимчасово недоступний. Спробуйте пізніше." };
  }
  return { kind: "transient", message: GENERIC_LOAD_ERROR };
}

export function fetchPublicPresentation(token, { signal } = {}) {
  return publicPresentationApi
    .get(`/realty/shares/${token}/`, { signal })
    .then((res) => res.data);
}

export function postPublicPresentationEvent(token, type, { signal } = {}) {
  return publicPresentationApi
    .post(`/realty/shares/${token}/events/`, { type }, { signal })
    .then((res) => res.data);
}

export function postPublicPresentationEventBestEffort(token, type) {
  if (!token || !type) return Promise.resolve();
  return postPublicPresentationEvent(token, type).catch(() => undefined);
}
